import { CardDon, DonCover, DonSectionI, HomeSectionFive, Motivation, Contact } from "../components"

const Don = () => {
  return (
    <div>
      <DonCover/>
      <DonSectionI/>
      <CardDon/>
      <Motivation/>
      <Contact/>
      <HomeSectionFive/>
    </div>
  )
}

export default Don
